const adminConfirmation = (
    {
        action,
        selectedAccountType,
        setSelectedAccountType
    }: {
        action:string,
        selectedAccountType:number | null,
        setSelectedAccountType: (value: number) => void
    }) => {
    return (    
        <>
            {action !== "changeAccountType" &&
                `Are you sure you want to ${action} this user?`}
            {action === "changeAccountType" && (
                <p className="text-start">Please select desired access level.</p>
            )}
            {action === "changeAccountType" && (
                <div className="mt-3">
                    <select
                        value={selectedAccountType || ""}
                        onChange={(e) => {
                            setSelectedAccountType(Number(e.target.value));
                        }}
                        className="form-select mb-4"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                    >
                        <option value="">Select account level</option>
                        <option value="0">Free</option>
                        <option value="1">Premium</option>
                        <option value="2">Advisor</option>
                        <option value="3">Service Provider</option>
                    </select>
                </div>
            )}
        </>
    )  
}

export default adminConfirmation;